import AxiosClient from '../../utils/AxiosClient';
import logAxiosError from '../../utils/logAxiosError';

export default async function createAdminNotification({
  title,
  body,
}: {
  title: string;
  body: string;
}) {
  const endpoint = '/api/adminNotifications';

  try {
    await AxiosClient.post(endpoint, { title, body });
  } catch (err) {
    logAxiosError('createAdminNotification', err);
  }
}
